export function camelToSnake(type: string) {
  if (!type) return ''

  return type.replace(/([A-Z])/g, '_$1').toLowerCase()
}
